import { Outlet } from "react-router-dom";

export default function ContentWrapper() {
  return (
    <div
      style={{
        backgroundColor: "#F5F5F5",
        flex: 1,
        overflow: "hidden", // 🔥 lock page scroll HERE
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Outlet />
    </div>
  );
}
